import { render, staticRenderFns } from "./LpAddressList.vue?vue&type=template&id=065fd6d6&scoped=true"
import script from "./LpAddressList.vue?vue&type=script&lang=js"
export * from "./LpAddressList.vue?vue&type=script&lang=js"
import style0 from "./LpAddressList.vue?vue&type=style&index=0&id=065fd6d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065fd6d6",
  null
  
)

export default component.exports